import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class FileService {

  constructor() { }

  public arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  public getFileExtention(text: string) {
    let result;
    switch (text) {
      case 'application/pdf':
        result = 'PDF';
        break;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        result = 'DOC';
        break;
      case 'image/jpeg':
        result = 'JPG';
        break;
      case 'image/png':
        result = 'PNG';
        break;
      case 'image/bmp':
        result = 'BMP';
        break;
      case 'image/tiff':
        result = 'TIF';
        break;
      case 'application/msword':
        result = 'DOC';
        break;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        result = 'XLSX';
        break;
    }
    return result;
  }

}
